import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, Output, EventEmitter, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, UntypedFormControl, UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { interval, Subscription } from 'rxjs';
import { debounceTime, map, distinctUntilChanged } from 'rxjs/operators';

import { ActivatedRoute, Router } from '@angular/router';
import { CustomerService } from '../../services/customer.service';
import { GlobalsService } from '../../services/globals.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';

import { Directive, HostListener } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import * as FileSaver from 'file-saver';
import { Location } from '@angular/common'

import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-reward-selector',
	templateUrl: './reward-selector.component.html',
	styleUrls: ['./reward-selector.component.scss']
})
export class RewardSelectorComponent implements OnInit {
	@Output() rewardselect = new EventEmitter < any > ();
	@Input('debtorno') debtorno;
	@Input('branchcode') branchcode;
	
	@ViewChild('cardModal') giftCardRef: ElementRef;
	
	rewards:any = [];
	config: any = [];
	user: any;
	pointtotal: any = 0;
	pending: any = 0;
	
	constructor(public fb: UntypedFormBuilder, public globalSearchService: GlobalSearchService, private modalService: NgbModal, private customerService: CustomerService) {
		
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
		});
		this.globalSearchService.user.subscribe(r => {
			this.user = r;
		});
		
	}
	
	ngOnInit(): void {
		const lookup = { debtorno: this.debtorno, branchcode: this.branchcode };
		this.customerService.getPoints(lookup).subscribe(async results => {
			this.pointtotal = results.pointbalance;
		});
		this.customerService.getPending(lookup).subscribe(async results => {
			this.pending = results.pointbalance;
		});
		this.customerService.getAvailableRewards(lookup).subscribe(async results => {
			this.rewards = results;
		});
		
	}
	
	gcModal(){
		const lookup = { debtorno: this.debtorno, branchcode: this.branchcode };
		this.customerService.getPending(lookup).subscribe(async results => {
			this.pending = results.pointbalance;
		});
		this.customerService.getAvailableRewards(lookup).subscribe(async results => {
			this.rewards = results;
			this.modalService.open(this.giftCardRef, { ariaLabelledBy: 'modal-title', size: 'lg' }).result.then((result) => {

			}, (reason) => {
			
			});
		});
		
	}
	
	chooseReward(chosen: any){
		this.rewardselect.emit(chosen);
		this.modalService.dismissAll();
		const lookup = { debtorno: this.debtorno, branchcode: this.branchcode };
		setTimeout(() => {
			this.customerService.getPending(lookup).subscribe(async results => {
				this.pending = results.pointbalance;
			});
		}, 1500);	
	
	}
}
